import Button from '@/components/Buttons/Button';
import bannerImageSrc from '@/images/avatarBannerImage.jpg';
import { useOpenCreateAvatarModal } from '@/pages/avatar';
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';
import { Collapse, IconButton, Typography } from '@mui/material';
import { useState } from 'react';

const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;

const BannerContainer = styled.div`
    background: #fff;
    border: 1px solid #dee4e9;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    height: 25rem;
    min-width: 65rem;
    position: relative;
    overflow: hidden;
`;

const InformationContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3.2rem;
    flex-shrink: 0;
    overflow: hidden;
`;

const GetStartedChip = styled(Typography)`
    background: ${({ theme }) => theme.colors.primary.bgMedium};
    color: ${({ theme }) => theme.colors.primary.main};
    border-radius: 16px;
    padding: 0.6rem 0.8rem 0.7rem;
    width: fit-content;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

const CreateAvatarButton = styled(Button)`
    padding: 1rem 1.6rem;
    width: fit-content;
`;

const Image = styled.img`
    height: 100%;
    width: 460px;
    box-sizing: border-box;
    flex-shrink: 1;
`;

interface IProps {
    show: boolean;
}

function AvatarsDiscoverabilityBanner({ show }: IProps) {
    const [open, setOpen] = useState(true);
    const openCreateAvatarModal = useOpenCreateAvatarModal();

    return (
        <Collapse in={open && show}>
            <BannerContainer>
                <CloseButton
                    disableRipple
                    onClick={() => {
                        setOpen(false);
                    }}>
                    <Close fontSize="large" />
                </CloseButton>
                <InformationContainer>
                    <GetStartedChip variant="h6">Get started</GetStartedChip>
                    <TextContainer>
                        <Typography variant="h3" lineHeight="2.732rem">
                            Create your first Personal Avatar
                        </Typography>
                        <Typography variant="body1" lineHeight="2.4rem">
                            Generate a realistic digital version of yourself to use across D-ID’s platform—
                            <br />
                            customized and ready for your needs.
                        </Typography>
                    </TextContainer>
                    <CreateAvatarButton variant="contained" color="primary" onClick={() => openCreateAvatarModal({})}>
                        Create Avatar
                    </CreateAvatarButton>
                </InformationContainer>
                <Image src={bannerImageSrc} />
            </BannerContainer>
        </Collapse>
    );
}

export default AvatarsDiscoverabilityBanner;
